import { useEffect, useState } from "react";
import { NODE_ENV } from "common/env";
import { ActionButton } from "../../Common/Buttons/ActionButton";
import { BannerContainer, BannerTextWrapper } from "./__styles__/StagingBanner";

export const StagingBanner = () => {
  const [showBanner, setShowBanner] = useState<boolean>(
    NODE_ENV !== "production",
  );

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--staging-banner-height",
      showBanner ? "32px" : "0px",
    );
    window.dispatchEvent(new Event("resize"));
  }, [showBanner]);

  return showBanner ?
      <BannerContainer environment={NODE_ENV}>
        <BannerTextWrapper>
          You're currently viewing the Forerunner {NODE_ENV} environment
        </BannerTextWrapper>
        <ActionButton
          icon="x"
          variant="inverted"
          onClick={() => setShowBanner(false)}
          data-testid="close-icon"
          aria-label="Close Banner"
        />
      </BannerContainer>
    : null;
};
